import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog4 = () => {
  // Données du blog avec le contenu sur la dépréciation des immobilisations
  const blogPost = {
    id: 5,
    title:
      "Dépréciation des immobilisations : protégez la valeur réelle de votre patrimoine",
    excerpt:
      "",
    content: `
      <div class="introduction-box p-4 mb-4" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-radius: 12px; border-left: 5px solid #dc3545;">
        <p class="lead mb-0">Vos immobilisations (bâtiments, machines, logiciels) sont le moteur de votre entreprise. Mais que se passe-t-il si leur valeur comptable ne reflète plus leur valeur économique réelle ? Une machine devenue obsolète ou un immeuble situé dans une zone en déclin peuvent fausser la perception de la santé financière de votre société.</p>
      </div>
      
      <p>C'est ici qu'intervient le concept de <strong>dépréciation d'actifs</strong>. Loin d'être une simple contrainte comptable, c'est un "bilan de santé" essentiel pour vos immobilisations. Il garantit que la valeur de vos actifs au bilan n'est pas surévaluée, assurant ainsi la fiabilité de vos états financiers.</p>
      
      <p>Cet article vous guide à travers les prescriptions de l'<strong>Acte uniforme relatif au droit comptable et à l'information financière (AUDCIF)</strong>, inspirées de la norme internationale <strong>IAS 36</strong> (publié en mars 2004), pour maîtriser le processus de dépréciation de vos immobilisations corporelles et incorporelles.</p>
      
      <p>Nous présenterons successivement les <strong>principes généraux</strong> et les <strong>modalités pratiques</strong>.</p>
      
      <h2 class="section-title">PRINCIPES GÉNÉRAUX</h2>
      
      <div class="highlight-box p-4 mb-4" style="background-color: #fff3cd; border-left: 4px solid #ffc107; border-radius: 8px;">
        <p class="mb-0">À la clôture de chaque exercice une entité doit apprécier s'il existe un quelconque indice qu'un actif a subi une perte de valeur. S'il existe un tel indice, l'entité doit estimer la valeur actuelle et la comparer avec la valeur nette comptable. L'actif doit être déprécié lorsque sa valeur nette comptable est supérieure à sa valeur actuelle. Pour les immobilisations incorporelles et corporelles, cette dépréciation est constatée par une <strong>dotation pour dépréciation</strong> (art. 46 AUCIF).</p>
      </div>
      
      <p>Selon l'article 42 de l'AUDCIF, à la clôture de chaque exercice, l'entité doit procéder au recensement et à l'évaluation de ses biens, créances et dettes à leur <strong>valeur effective du moment</strong>, dite valeur actuelle. La valeur actuelle est une valeur d'estimation du moment, qui s'apprécie en fonction du marché et de l'utilité de l'élément pour l'entité.</p>
      
      <p>L'utilité de l'élément pour l'entité est à déterminer dans le cadre de la continuité de l'exploitation ou d'utilisation, telle que définie à l'article 39 de l'Acte uniforme, ou, le cas échéant, dans l'hypothèse de non-continuité.</p>
      
      <div class="key-concept-box p-4 mb-4" style="background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%); border-radius: 12px; border-left: 5px solid #17a2b8;">
        <h4 style="color: #0c5460; margin-bottom: 15px;"> Concept clé à retenir</h4>
        <p class="mb-0"><strong>L'amortissement est une notion différente de la notion de perte de valeur (dépréciation).</strong> L'amortissement consiste pour l'entité à répartir systématiquement le montant amortissable du coût du bien sur sa durée d'utilité selon un plan prédéfini (approche économique retenue par le Système comptable OHADA). <strong>La perte de valeur vient s'ajouter à l'amortissement déjà pratiqué.</strong></p>
      </div>
      
      <h2 class="section-title">MODALITÉS PRATIQUES</h2>
      
      <h3>Identification de la perte de valeur d'un actif</h3>
      
      <p>Une entité doit apprécier à la clôture de chaque exercice, s'il existe un indice qu'un actif (immobilisation incorporelle ou corporelle) peut avoir subi une perte de valeur :</p>
      
      <div class="process-steps mb-4">
        <div class="step-item d-flex align-items-start mb-3 p-3" style="background-color: #f8f9fa; border-radius: 8px; border-left: 4px solid #28a745;">
          <div class="step-number me-3" style="background-color: #28a745; color: white; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; font-weight: bold;">1</div>
          <div>
            <strong>Pas d'indice de perte de valeur :</strong> Aucun test de dépréciation n'est requis
          </div>
        </div>
        <div class="step-item d-flex align-items-start mb-3 p-3" style="background-color: #fff3cd; border-radius: 8px; border-left: 4px solid #ffc107;">
          <div class="step-number me-3" style="background-color: #ffc107; color: black; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; font-weight: bold;">2</div>
          <div>
            <strong>Existence d'un indice :</strong> L'entité doit estimer la valeur actuelle de l'immobilisation. Si la valeur actuelle de l'immobilisation est inférieure à sa valeur nette comptable, une dépréciation doit être comptabilisée.
          </div>
        </div>
      </div>
      
      <h3>Indices de perte de valeur</h3>
      
      <p>Une entité doit considérer toutes les sources d'information pour identifier des <strong>indices externes</strong> et <strong>internes</strong>.</p>
      
      <h4> Indices externes</h4>
      
      <ul class="custom-list mb-4">
        <li>La baisse de la valeur de marché de l'actif, supérieure à celle attendue du fait du passage du temps ou de l'utilisation normale de l'actif</li>
        <li>L'augmentation des taux d'intérêt du marché ou d'autres taux de rendements durant l'exercice et la probabilité que ces augmentations affecteront le taux d'actualisation utilisé dans le calcul de la valeur d'utilité d'un actif et diminueront de façon significative la valeur actuelle de l'actif</li>
        <li>D'importants changements, ayant un effet négatif sur l'entité, survenus au cours de l'exercice ou pouvant survenir dans un proche avenir, dans l'environnement technologique, économique ou juridique ou sur le marché dans lequel l'entité opère ou dans le marché auquel l'actif est dévolu</li>
        <li>La valeur comptable de l'actif net de l'entité est supérieure à sa capitalisation boursière</li>
      </ul>
      
      <h4> Indices internes</h4>
      
      <ul class="custom-list mb-4">
        <li>L'obsolescence ou de dégradation physique d'un actif</li>
        <li>L'évolution de la performance économique d'un actif (par exemple, les flux de trésorerie nets actualisés ou résultats opérationnels générés par l'actif sont sensiblement plus mauvais que ceux budgétés)</li>
        <li>Des changements importants, ayant un effet négatif sur l'entité, survenus au cours de l'exercice ou susceptibles de survenir dans un proche avenir concernant le degré ou le mode d'utilisation d'un actif tel qu'il est utilisé ou tel que l'on s'attend à l'utiliser. Ces changements incluent la mise hors service de l'actif, les plans d'abandon ou de restructuration du secteur d'activité auquel un actif appartient et les plans de sortie d'un actif avant la date prévue préalablement</li>
      </ul>
      
      <h3>Détermination de la valeur actuelle d'une immobilisation</h3>
      
      <h4>Critères de détermination de la valeur actuelle d'une immobilisation</h4>
      
      <p>La <strong>valeur actuelle</strong> d'une immobilisation incorporelle ou corporelle représente son coût actuel. Le coût actuel d'un actif est le montant de trésorerie ou d'équivalents de trésorerie qu'il faudrait payer si le même actif ou un actif équivalent, était acquis actuellement.</p>
      
      <p>Ce coût correspond au <strong>prix actuel d'achat</strong> de l'immobilisation (référence au marché énoncée à l'article 42 de l'AUDCIF) à la date de l'inventaire, majoré éventuellement des charges accessoires d'acquisition, ou le <strong>coût actuel de production</strong> pour les immobilisations produites par l'entité pour elle-même et n'ayant pas d'équivalent sur le marché.</p>
      
      <p>Ces coûts sont corrigés en baisse en fonction de l'usure ou de l'âge de l'immobilisation (référence à l'utilité du bien pour l'entité énoncée à l'article 42 de l'AUDCIF).</p>
      
      <p>La recherche de la valeur actuelle doit prendre en compte tout à la fois :</p>
      
      <div class="considerations-grid row mb-4">
        <div class="col-md-6 mb-3">
          <div class="consideration-card p-4 h-100" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 12px; border-left: 5px solid #2196f3;">
            <h5 style="color: #0d47a1;"> La globalité de l'entité</h5>
            <p class="mb-0">Il s'agit de se placer du point de vue d'un acquéreur de l'entité qui cherche à connaître la valeur du bien (dans le cadre de l'exploitation de celle-ci)</p>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="consideration-card p-4 h-100" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%); border-radius: 12px; border-left: 5px solid #9c27b0;">
            <h5 style="color: #4a148c;"> La continuité de l'exploitation</h5>
            <p class="mb-0">De l'entité, ou, le cas échéant, la non-continuité de l'exploitation de l'entité ou d'une branche d'activité, ou la non-utilisation future du bien</p>
          </div>
        </div>
      </div>
      
      <div class="warning-box p-4 mb-4" style="background-color: #fff3cd; border: 2px solid #ffc107; border-radius: 12px;">
        <h4 style="color: #856404; margin-bottom: 15px;"> À Retenir</h4>
        <p><strong>Il ne faut pas confondre la valeur actuelle avec la valeur de revente immédiate.</strong> La valeur actuelle s'apprécie dans une perspective de continuité d'exploitation. C'est le montant qu'il faudrait débourser pour acquérir un actif équivalent, compte tenu de son âge et de son état, pour continuer à l'utiliser dans l'entreprise.</p>
        <p class="mb-0">Ce n'est que si l'entreprise prévoit de céder l'actif ou d'arrêter l'activité que sa valeur actuelle se rapprochera de son prix de vente net.</p>
      </div>
      
      <h3> EXEMPLE PRATIQUE</h3>
      
      <div class="example-box p-4 mb-4" style="background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c8 100%); border-radius: 12px; border-left: 5px solid #28a745; box-shadow: 0 4px 15px rgba(40, 167, 69, 0.1);">
        <h5 style="color: #155724; margin-bottom: 20px;"> Cas du pont roulant</h5>
        <p>Une entité acquiert un pont roulant de 30 tonnes, qu'elle met en service le 31 décembre 20.N ; <strong>coût d'entrée : 300 000 000 F.</strong></p>
        <p>Dans le bilan, au 31 décembre (donc le soir-même), ce bien figurera au bilan pour 300 000 000 F (l'amortissement étant négligeable) si du moins sa valeur actuelle apparaît au moins égale à 300 000 000 F.</p>
        
        <div class="analysis-section p-3 mt-3" style="background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;">
          <p><strong> Analyse :</strong> Si ce pont roulant a été acheté et installé dans des conditions normales, en fonction des prix actuels du marché, un acquéreur éventuel de l'entité, trouvant ce bien à l'actif, ne peut pas l'estimer moins de 300 000 000 F, car c'est sans doute le coût qu'il faut au minimum engager pour disposer d'un tel matériel neuf.</p>
          <p><strong> Mais attention :</strong> Il est pourtant bien évident que si, à cette date, et même en disposant de quelque délai, on cherchait à céder cet équipement, on serait loin d'en tirer 300 000 000 F, peut-être à peine la moitié (frais de démontage, remontage...), à supposer qu'on trouve un acquéreur.</p>
        </div>
        
        <div class="conclusion-section p-3 mt-3" style="background-color: rgba(40, 167, 69, 0.1); border-radius: 8px;">
          <p class="mb-0"><strong> Conclusion :</strong> Cette valeur actuelle fait donc appel à la globalité et à la continuité d'exploitation de l'entité ; elle ne doit pas être confondue avec une valeur probable de revente du bien isolé (sauf pour les biens ayant un large marché : matières premières, produits finis, marchandises).</p>
        </div>
      </div>
      
      <p>Le lien existant entre la définition de la "valeur actuelle" et l'hypothèse de continuité d'exploitation est donc très étroit.</p>
      
      <p>La valeur actuelle peut être égale au prix probable de revente du bien isolé (net des frais de revente), mais dans deux cas seulement :</p>
      
      <div class="cases-grid row mb-4">
        <div class="col-md-6 mb-3">
          <div class="case-card p-4 h-100" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 12px; border-left: 5px solid #fdcb6e;">
            <h5 style="color: #856404;"> Cas 1</h5>
            <p class="mb-0"><strong>Bien cessible sur un marché très actif</strong>, ce qui est rarissime pour les immobilisations ; se rapprochent de ce cas les véhicules (camions, tracteurs...)</p>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="case-card p-4 h-100" style="background: linear-gradient(135deg, #ffeaa7 0%, #fab1a0 100%); border-radius: 12px; border-left: 5px solid #e17055;">
            <h5 style="color: #a0522d;"> Cas 2</h5>
            <p class="mb-0"><strong>Non-continuité de l'exploitation</strong>, ou non-continuité d'utilisation du bien ; dans ce cas, la valeur actuelle "tombe" au niveau du prix de vente probable du bien isolé</p>
          </div>
        </div>
      </div>
      
      <div class="note-box p-3 mb-4" style="background-color: #f8f9fa; border-left: 4px solid #6c757d; border-radius: 8px;">
        <p class="mb-0"><strong>📝 Note importante :</strong> La référence au "marché" ne doit pas conduire à retenir le prix du marché comme valeur actuelle, mais seulement comme base de calcul de cette valeur.</p>
      </div>
      
      <h4>Valeur actuelle d'une immobilisation amortissable</h4>
      
      <p>Il faut tenir compte de l'âge de l'immobilisation, donc du plan d'amortissement.</p>
      
      <h3> EXEMPLE DE CALCUL DÉTAILLÉ</h3>
      
      <div class="example-detailed p-4 mb-4" style="background: linear-gradient(135deg, #e8f4fd 0%, #d1ecf1 100%); border-radius: 15px; border: 2px solid #17a2b8; box-shadow: 0 6px 20px rgba(23, 162, 184, 0.15);">
        <h5 style="color: #0c5460; margin-bottom: 20px;"> Matériel industriel - Calcul de dépréciation</h5>
        
        <div class="calculation-steps">
          <div class="step-calculation p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
            <h6 style="color: #0c5460;"> Données initiales</h6>
            <ul>
              <li>Matériel industriel neuf acquis pour : <strong>10 000 000 F</strong></li>
              <li>Amortissement : <strong>linéaire sur 5 ans</strong> (valeur résiduelle nulle)</li>
              <li>Taux d'amortissement : <strong>20% par an</strong></li>
            </ul>
          </div>
          
          <div class="step-calculation p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
            <h6 style="color: #0c5460;"> Situation à la fin de la 3e année</h6>
            <p>Valeur nette comptable : 100% - (3 × 20%) = <strong>40%</strong></p>
            <p>Soit : <strong>4 000 000 F</strong></p>
          </div>
          
          <div class="step-calculation p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
            <h6 style="color: #0c5460;"> Nouveau prix du marché</h6>
            <p>Le même matériel (neuf) coûte désormais : <strong>6 000 000 F</strong></p>
            <p><em>Prix en forte baisse par rapport au prix d'acquisition initial</em></p>
          </div>
          
          <div class="calculation-result p-4 mt-4" style="background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%); border-radius: 12px; border-left: 5px solid #28a745;">
            <h6 style="color: #155724; margin-bottom: 15px;"> Calcul de la valeur actuelle</h6>
            <div class="formula-box p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.9); border-radius: 8px; font-family: monospace; text-align: center; font-size: 1.1rem;">
              Valeur actuelle = 6 000 000 × 0,40 = <strong style="color: #28a745;">2 400 000 F</strong>
            </div>
            <p>Cette valeur est <strong>sensiblement inférieure</strong> aux 4 000 000 F figurant en comptabilité.</p>
            <p class="mb-0"><strong> Action requise :</strong> Pratiquer une dotation pour dépréciation de <strong>1 600 000 F</strong> (4 000 000 - 2 400 000)</p>
          </div>
        </div>
      </div>
      
      <div class="accounting-entry p-4 mb-4" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 12px; border-left: 5px solid #ffc107;">
        <h5 style="color: #856404; margin-bottom: 15px;"> Écriture comptable</h5>
        <div class="journal-entry" style="font-family: monospace; background-color: rgba(255, 255, 255, 0.9); padding: 15px; border-radius: 8px;">
          <div class="row">
            <div class="col-8"><strong>6913</strong> Dotation pour dépréciation des immobilisations corporelles</div>
            <div class="col-4 text-end"><strong>1 600 000</strong></div>
          </div>
          <div class="row">
            <div class="col-8 ps-4">à <strong>2941</strong> Provisions pour dépréciation du matériel et outillage industriel</div>
            <div class="col-4 text-end"><strong>1 600 000</strong></div>
          </div>
        </div>
        <p class="mt-3 mb-0"><strong>Résultat :</strong> La valeur nette comptable du matériel après dépréciation s'élève à <strong>2 400 000 F</strong> et constitue la nouvelle base amortissable du matériel qui sera amortie sur la durée restant à courir (<strong>deux ans</strong>).</p>
      </div>
      
      <div class="counter-example p-4 mb-4" style="background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%); border-radius: 12px; border-left: 5px solid #dc3545;">
        <h5 style="color: #721c24; margin-bottom: 15px;"> Cas inverse - Prix en hausse</h5>
        <p>Si inversement, ce matériel vaut actuellement (neuf) environ <strong>16 000 000 F</strong>, sa valeur actuelle sera plutôt de :</p>
        <div class="formula-box p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.9); border-radius: 8px; font-family: monospace; text-align: center; font-size: 1.1rem;">
          16 000 000 × 0,4 = <strong style="color: #dc3545;">6 400 000 F</strong>
        </div>
        <p>Elle est ici <strong>supérieure</strong> à la valeur nette comptable (4 000 000 F). En application de la <strong>convention de prudence</strong>, la valeur nette comptable de 4 000 000 F sera maintenue au bilan.</p>
        <p class="mb-0"><em>Aucune réévaluation ne sera pratiquée dans le respect du principe de prudence.</em></p>
      </div>

      <div class="schema-intro mb-3">
  <h4><strong>Schéma récapitulatif du mode opératoire</strong></h4>
  <p>Le schéma ci-dessous résume le mode opératoire de la constatation d'une dépréciation d'une immobilisation incorporelle ou corporelle :</p>
</div>

<div class="blog-featured-image-inline mb-4 text-center">
  <img
    src="/assets/images/image30.png"
    alt="Schéma récapitulatif du processus de dépréciation"
    class="img-fluid rounded"
    style="max-width: 80%; height: auto; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);"
  />
</div>
      <div class="flowchart-container p-4 mb-4" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-radius: 15px; border: 2px solid #6c757d;">
        <h5 class="text-center mb-4" style="color: #495057;"> Processus de dépréciation des immobilisations</h5>
        
        <div class="flowchart-steps">
          <div class="flowchart-step text-center mb-4 p-3" style="background-color: #e3f2fd; border-radius: 10px; border: 2px solid #2196f3;">
            <strong>1. Identification des indices de perte de valeur</strong>
            <p class="mb-0 mt-2">Indices externes et internes</p>
          </div>
          
          <div class="text-center mb-3">
            <span style="font-size: 2rem; color: #6c757d;">⬇️</span>
          </div>
          
          <div class="flowchart-step text-center mb-4 p-3" style="background-color: #fff3cd; border-radius: 10px; border: 2px solid #ffc107;">
            <strong>2. Test de dépréciation si indices détectés</strong>
            <p class="mb-0 mt-2">Calcul de la valeur actuelle</p>
          </div>
          
          <div class="text-center mb-3">
            <span style="font-size: 2rem; color: #6c757d;">⬇️</span>
          </div>
          
          <div class="flowchart-step text-center mb-4 p-3" style="background-color: #f8d7da; border-radius: 10px; border: 2px solid #dc3545;">
            <strong>3. Comparaison : Valeur actuelle vs Valeur nette comptable</strong>
            <p class="mb-0 mt-2">Si VA < VNC → Dépréciation</p>
          </div>
          
          <div class="text-center mb-3">
            <span style="font-size: 2rem; color: #6c757d;">⬇️</span>
          </div>
          
          <div class="flowchart-step text-center mb-4 p-3" style="background-color: #d4edda; border-radius: 10px; border: 2px solid #28a745;">
            <strong>4. Comptabilisation et ajustement du plan d'amortissement</strong>
            <p class="mb-0 mt-2">Dotation pour dépréciation + Nouveau plan</p>
          </div>
        </div>
      </div>
      
      <h3>Particularités liées à la détermination de la valeur actuelle</h3>
      
      <h4>Conséquences de la constatation d'une perte de valeur</h4>
      
      <p>Après la comptabilisation d'une perte de valeur, <strong>le plan d'amortissement de l'actif doit être ajusté</strong> pour les exercices suivants, afin que la valeur comptable révisée, diminuée de sa valeur résiduelle, puisse être répartie de façon systématique sur sa durée d'utilité restant à courir.</p>
      
      <h4>Ajustements ultérieurs du montant de la dépréciation</h4>
      
      <p>Après un premier test de dépréciation, l'entité procède à un autre test de dépréciation lorsqu'elle décèle à la clôture d'exercice, un indice indiquant qu'une perte de valeur antérieurement constatée peut avoir diminué ou disparu (les tests ultérieurs ne sont donc pas liés simplement au temps passé).</p>
      
      <p>L'entité doit mettre en œuvre un nouveau test de dépréciation afin de déterminer la valeur actuelle de cette immobilisation.</p>
      
      <p>La dépréciation antérieurement constatée doit alors faire l'objet d'une <strong>augmentation (dotation)</strong> ou d'une <strong>diminution (reprise)</strong>.
      
      <p>Pour ce qui concerne les reprises, la valeur comptable de l'immobilisation augmentée en raison de la reprise d'une perte de valeur ne doit pas être supérieure à la valeur comptable qui aurait été déterminée (nette des amortissements) si aucune perte de valeur n'avait été comptabilisée pour cette immobilisation au cours des exercices antérieurs. Cette disposition vise à éviter la réévaluation ultérieure d'une immobilisation dépréciée.</p>
      
      <h3> EXEMPLE DE REPRISE DE DÉPRÉCIATION</h3>
      
      <div class="example-box p-4 mb-4" style="background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c8 100%); border-radius: 12px; border-left: 5px solid #28a745; box-shadow: 0 4px 15px rgba(40, 167, 69, 0.1);">
        <h5 style="color: #155724; margin-bottom: 20px;">💼 Matériel industriel - Évolution sur plusieurs exercices</h5>
        
        <div class="timeline-steps">
          <div class="step-timeline p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
            <h6 style="color: #155724;"> Année N-1 : Acquisition</h6>
            <p>Matériel industriel acquis le 02 janvier pour <strong>30 000 000 F</strong></p>
            <p>Amortissement linéaire sur <strong>10 ans</strong></p>
            <p>Dotation annuelle : <strong>3 000 000 F</strong> (30 000 000 ÷ 10)</p>
          </div>
          
          <div class="step-timeline p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
            <h6 style="color: #155724;"> Année N : Test de dépréciation</h6>
            <p>Après 2 années d'utilisation :</p>
            <ul>
              <li>Valeur nette comptable : <strong>24 000 000 F</strong> (30 000 000 - 2 × 3 000 000)</li>
              <li>Valeur actuelle estimée : <strong>20 000 000 F</strong></li>
              <li>Perte de valeur constatée : <strong>4 000 000 F</strong></li>
              <li>Nouvelle VNC : <strong>20 000 000 F</strong></li>
              <li>Nouveau plan d'amortissement : <strong>2 500 000 F/an</strong> sur 8 ans restants</li>
            </ul>
          </div>
          
          <div class="step-timeline p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
            <h6 style="color: #155724;"> Année N+2 : Reprise de dépréciation</h6>
            <p>Situation à la fin N+2 :</p>
            <ul>
              <li>Valeur nette comptable actuelle : <strong>15 000 000 F</strong> (20 000 000 - 2 × 2 500 000)</li>
              <li>Nouvelle valeur actuelle : <strong>17 000 000 F</strong></li>
              <li>VNC théorique sans dépréciation : <strong>18 000 000 F</strong> (30 000 000 - 4 × 3 000 000)</li>
            </ul>
            
            <div class="calculation-result p-3 mt-3" style="background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%); border-radius: 8px;">
              <p><strong> Reprise possible :</strong> 2 000 000 F (17 000 000 - 15 000 000)</p>
              <p><strong> Plafond respecté :</strong> 17 000 000 F < 18 000 000 F</p>
              <p><strong> Nouvelle VNC :</strong> 17 000 000 F</p>
            </div>
          </div>
          
          <div class="step-timeline p-3 mb-3" style="background-color: rgba(255, 243, 205, 0.8); border-radius: 10px;">
            <h6 style="color: #856404;"> Cas limite : Si valeur actuelle = 19 000 000 F</h6>
            <p>Reprise limitée à <strong>3 000 000 F</strong> (18 000 000 - 15 000 000)</p>
            <p>Nouvelle VNC plafonée à <strong>18 000 000 F</strong></p>
          </div>
        </div>
      </div>
      
      <h3>Impossibilité d'obtention d'un prix de marché</h3>
      
      <p>Deux situations peuvent se présenter :</p>
      
      <div class="situations-grid row mb-4">
        <div class="col-md-6 mb-3">
          <div class="situation-card p-4 h-100" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 12px; border-left: 5px solid #2196f3;">
            <h5 style="color: #0d47a1;"> Situation 1 : Évaluation de groupe</h5>
            <p>S'il existe un indice qu'une immobilisation isolée peut être dépréciée, et qu'il est impossible de déterminer isolément son prix de marché, il convient de déterminer le prix de marché du <strong>groupe d'immobilisations</strong> auquel l'actif appartient.</p>
            
            <div class="allocation-process p-3 mt-3" style="background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;">
              <p><strong>Ordre d'affectation de la perte :</strong></p>
              <ol>
                <li>Réduction de la valeur comptable du <strong>goodwill</strong> affecté au groupe d'actifs</li>
                <li>Affectation aux autres immobilisations <strong>au prorata</strong> de leur valeur comptable</li>
              </ol>
              <p class="mb-0"><em>Note : La dépréciation du goodwill ne peut jamais faire l'objet d'une reprise.</em></p>
            </div>
          </div>
        </div>
        
        <div class="col-md-6 mb-3">
          <div class="situation-card p-4 h-100" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 12px; border-left: 5px solid #ffc107;">
            <h5 style="color: #856404;"> Situation 2 : Mention en annexe</h5>
            <p>S'il n'existe pas un marché actif permettant de connaître le prix de marché de l'immobilisation, alors que l'indice de perte de valeur est avéré, l'entité doit porter une mention dans les <strong>Notes annexes</strong> :</p>
            
            <div class="mention-requirements p-3 mt-3" style="background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;">
              <ul class="mb-0">
                <li>Indication de l'existence d'un indice de perte de valeur et sa nature</li>
                <li>Justification de l'impossibilité d'obtention d'un prix de marché</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div class="consistency-box p-4 mb-4" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%); border-radius: 12px; border-left: 5px solid #9c27b0;">
        <h5 style="color: #4a148c;"> Principe de cohérence</h5>
        <p>Les immobilisations ou groupes d'actifs immobilisés au niveau desquels est réalisé le test de dépréciation doivent être déterminés de façon <strong>cohérente et permanente</strong>, à chaque évaluation de la valeur actuelle.</p>
        
        <div class="determination-criteria p-3 mt-3" style="background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;">
          <p><strong>Critères de détermination des groupes :</strong></p>
          <ul class="mb-0">
            <li><strong>Ligne de produits</strong></li>
            <li><strong>Secteur d'activité</strong></li>
            <li><strong>Implantation géographique</strong></li>
          </ul>
        </div>
      </div>
      
      <h3> EXEMPLE PRATIQUE - GROUPE D'ACTIFS</h3>
      
      <div class="example-group p-4 mb-4" style="background: linear-gradient(135deg, #e8f4fd 0%, #d1ecf1 100%); border-radius: 15px; border: 2px solid #17a2b8; box-shadow: 0 6px 20px rgba(23, 162, 184, 0.15);">
        <h5 style="color: #0c5460; margin-bottom: 20px;"> Dépréciation d'un groupe d'actifs industriels</h5>
        
        <div class="group-composition p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #0c5460;"> Composition du groupe (VNC au 31/12/N)</h6>
          <table class="w-100" style="margin-top: 15px;">
            <tbody>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;"><strong>Fonds commercial</strong></td>
                <td class="text-end" style="padding: 8px 0;"><strong>20 000 000 F</strong></td>
              </tr>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;"><strong>Terrain</strong></td>
                <td class="text-end" style="padding: 8px 0;"><strong>50 000 000 F</strong></td>
              </tr>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;"><strong>Immeuble industriel</strong></td>
                <td class="text-end" style="padding: 8px 0;"><strong>150 000 000 F</strong></td>
              </tr>
              <tr style="border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px 0;"><strong>Flotte de camions</strong></td>
                <td class="text-end" style="padding: 8px 0;"><strong>40 000 000 F</strong></td>
              </tr>
              <tr style="border-top: 2px solid #17a2b8; font-weight: bold;">
                <td style="padding: 12px 0;"><strong>TOTAL</strong></td>
                <td class="text-end" style="padding: 12px 0;"><strong>260 000 000 F</strong></td>
              </tr>
            </tbody>
          </table>
          <p class="mt-3 mb-0">Valeur actuelle globale déterminée : <strong>200 000 000 F</strong></p>
        </div>
        
        <div class="calculation-steps">
          <div class="step-calc p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
            <h6 style="color: #0c5460;"> Calcul de la dépréciation globale</h6>
            <div class="formula-box p-3 mb-2" style="background-color: rgba(23, 162, 184, 0.1); border-radius: 8px; font-family: monospace; text-align: center; font-size: 1.1rem;">
              260 000 000 - 200 000 000 = <strong style="color: #dc3545;">60 000 000 F</strong>
            </div>
          </div>
          
          <div class="step-calc p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
            <h6 style="color: #0c5460;"> Ventilation de la dépréciation</h6>
            <p><strong>Étape 1 :</strong> Imputation sur le fonds commercial</p>
            <p>Dépréciation du fonds commercial : <strong>20 000 000 F</strong> (valeur ramenée à 0)</p>
            
            <p><strong>Étape 2 :</strong> Répartition du solde (40 000 000 F) au prorata</p>
            <p>Base de répartition : 50 000 000 + 150 000 000 + 40 000 000 = <strong>240 000 000 F</strong></p>
            
            <table class="w-100 mt-3">
              <tbody>
                <tr style="border-bottom: 1px solid #dee2e6;">
                  <td style="padding: 8px 0;">Terrain</td>
                  <td style="padding: 8px 0;">40 000 000 × (50 000 000 ÷ 240 000 000)</td>
                  <td class="text-end" style="padding: 8px 0;"><strong>8 333 333 F</strong></td>
                </tr>
                <tr style="border-bottom: 1px solid #dee2e6;">
                  <td style="padding: 8px 0;">Immeuble</td>
                  <td style="padding: 8px 0;">40 000 000 × (150 000 000 ÷ 240 000 000)</td>
                  <td class="text-end" style="padding: 8px 0;"><strong>25 000 000 F</strong></td>
                </tr>
                <tr style="border-bottom: 1px solid #dee2e6;">
                  <td style="padding: 8px 0;">Camions</td>
                  <td style="padding: 8px 0;">40 000 000 × (40 000 000 ÷ 240 000 000)</td>
                  <td class="text-end" style="padding: 8px 0;"><strong>6 666 667 F</strong></td>
                </tr>
                <tr style="border-top: 2px solid #17a2b8; font-weight: bold;">
                  <td style="padding: 12px 0;">TOTAL</td>
                  <td style="padding: 12px 0;"></td>
                  <td class="text-end" style="padding: 12px 0;"><strong>40 000 000 F</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      <h3>Comptabilisation des pertes de valeur suite à une réévaluation</h3>
      
      <p>Dans le cas où une immobilisation corporelle a fait l'objet antérieurement d'une réévaluation, la perte de valeur s'impute sur l'écart de réévaluation ; le solde éventuel est enregistré en charges.</p>
      
      <div class="revaluation-example p-4 mb-4" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 12px; border-left: 5px solid #ffc107;">
        <h5 style="color: #856404; margin-bottom: 15px;"> Exemple - Bâtiment réévalué</h5>
        
        <div class="situation-data p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;">
          <p><strong>Contexte :</strong></p>
          <ul>
            <li>Bâtiment industriel ayant subi une perte de valeur de <strong>15 000 000 F</strong></li>
            <li>Valeur comptable réévaluée avant dépréciation : <strong>100 000 000 F</strong></li>
            <li>Écart de réévaluation en capitaux propres : <strong>6 000 000 F</strong></li>
          </ul>
        </div>
        
        <div class="accounting-treatment p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;">
          <h6 style="color: #856404;"> Traitement comptable</h6>
          <p><strong>Imputation prioritaire sur l'écart de réévaluation :</strong> 6 000 000 F</p>
          <p><strong>Solde en charges :</strong> 15 000 000 - 6 000 000 = <strong>9 000 000 F</strong></p>
        </div>
        
        <div class="journal-entries" style="font-family: monospace; background-color: rgba(255, 255, 255, 0.9); padding: 15px; border-radius: 8px;">
          <div class="row mb-2">
            <div class="col-8"><strong>1062</strong> Écarts de réévaluation libre</div>
            <div class="col-4 text-end"><strong>6 000 000</strong></div>
          </div>
          <div class="row mb-2">
            <div class="col-8"><strong>6914</strong> Dotations pour dépréciations des immobilisations corporelles</div>
            <div class="col-4 text-end"><strong>9 000 000</strong></div>
          </div>
          <div class="row">
            <div class="col-8 ps-4">à <strong>2931</strong> Dépréciations des bâtiments industriels</div>
            <div class="col-4 text-end"><strong>15 000 000</strong></div>
          </div>
        </div>
      </div>
      
      <h3>Informations à fournir dans les Notes annexes</h3>
      
      <div class="annexe-info p-4 mb-4" style="background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%); border-radius: 12px; border-left: 5px solid #17a2b8;">
        <h5 style="color: #0c5460; margin-bottom: 15px;"> Obligations d'information</h5>
        
        <p>Les informations suivantes doivent être fournies dans les Notes annexes :</p>
        
        <ul class="custom-list mb-3">
          <li>La <strong>catégorie de l'immobilisation</strong> ayant fait l'objet de dépréciation</li>
          <li>Le <strong>montant des pertes de valeur</strong> comptabilisées en résultat au cours de la période</li>
          <li>Le <strong>montant des reprises</strong> comptabilisées en résultat au cours de la période</li>
        </ul>
        
        <div class="transparency-note p-3" style="background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;">
          <p class="mb-0"><strong> Objectif :</strong> Assurer la transparence et permettre aux utilisateurs des états financiers de comprendre l'impact des dépréciations sur la situation financière de l'entité.</p>
        </div>
      </div>
      
      <div class="conclusion-section p-4 mb-4" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-radius: 15px; border: 2px solid #6c757d; box-shadow: 0 4px 15px rgba(108, 117, 125, 0.1);">
        <h3 style="color: #495057; margin-bottom: 20px;"> CONCLUSION</h3>
        
        <p>La dépréciation des immobilisations n'est pas une simple formalité comptable, mais un <strong>principe fondamental</strong> qui garantit la fiabilité et la sincérité des états financiers de votre entreprise. Le respect des procédures d'évaluation et la fourniture des informations requises par l'Acte uniforme sont essentiels pour présenter une image fidèle de votre patrimoine aux partenaires financiers, aux actionnaires et aux autres parties prenantes.</p>
        
        <p>Cependant, la complexité des calculs de valeur actuelle et la nécessité d'une analyse objective et conforme aux normes rendent l'exercice délicat. C'est pourquoi l'accompagnement par un <strong>expert-comptable</strong> est un choix judicieux. Ce professionnel ne se contente pas de vous aider à appliquer les dispositions réglementaires : il agit en véritable partenaire stratégique, en réalisant des évaluations précises et en vous fournissant des conseils éclairés pour optimiser la gestion de vos actifs.</p>
        
        <div class="key-benefits p-3 mt-3" style="background-color: rgba(40, 167, 69, 0.1); border-radius: 8px;">
          <p><strong> Faire appel à un expert-comptable, c'est s'assurer que votre entreprise :</strong></p>
          <ul class="mb-0">
            <li>Respecte scrupuleusement ses obligations comptables et réglementaires</li>
            <li>Sécurise la valeur de ses immobilisations</li>
            <li>Bénéficie d'une expertise technique pointue</li>
            <li>Optimise sa croissance durable</li>
          </ul>
        </div>
      </div>
      
      <div class="resources-section p-4 mb-4" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 12px; border-left: 5px solid #2196f3;">
        <h4 style="color: #0d47a1; margin-bottom: 15px;"> Pour aller plus loin</h4>
        <ul class="resources-list mb-0">
          <li><strong>Site officiel de l'OHADA :</strong> <a href="https://www.ohada.org" target="_blank" rel="noopener">www.ohada.org</a></li>
          <li><strong>Jurisprudence et documentation :</strong> <a href="https://www.ohada.com" target="_blank" rel="noopener">www.ohada.com</a></li>
          <li><strong>Site de l'Ordre des Experts-comptables :</strong> <a href="https://oeccabenin.bj/" target="_blank" rel="noopener">https://oeccabenin.bj/</a></li>
        </ul>
      </div>
    </div>
  </div>`,
    image: "/assets/images/image30.png",
    categories: ["Comptabilité", "OHADA", "Normes"],
    tags: [
      "Dépréciation",
      "Immobilisations",
      "OHADA",
      "Expert-comptable",
      "IAS 36",
      "Valeur actuelle",
    ],
    date: "25 Septembre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable spécialisé en normes OHADA",
    readTime: "10 min",
    featured: true,
  };

  // Articles similaires

  return (
    <>
      <Header />

      <div className="blog-content py-5">
        <div className="container">
          {/* Fil d'Ariane */}
          <nav className="breadcrumb-container mb-4">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none">
                  Accueil
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/actualites/blog" className="text-decoration-none">
                  Blog
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {blogPost.title}
              </li>
            </ol>
          </nav>

          <div className="row">
            <div className="col-lg-8">
              {/* Catégorie et Titre */}
              <div className="blog-header mb-4">
                <div className="categories-badges mb-2">
                  {blogPost.categories.map((category, index) => (
                    <span key={index} className="category-badge me-2">
                      {category}
                    </span>
                  ))}
                </div>
                <h1 className="blog-title">{blogPost.title}</h1>

                {/* Métadonnées de l'article */}
                <div className="blog-meta d-flex align-items-center mt-3">
                  <div className="meta-item d-flex align-items-center">
                    <FaCalendarAlt className="meta-icon" />
                    <span>{blogPost.date}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaUser className="meta-icon" />
                    <span>{blogPost.author}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaClock className="meta-icon" />
                    <span>{blogPost.readTime} de lecture</span>
                  </div>
                </div>
              </div>

              {/* Image principale */}
              

              {/* Extrait de l'article */}
              <div className="blog-excerpt mb-4">
                <p className="lead">{blogPost.excerpt}</p>
              </div>

              {/* Contenu principal */}
              <div
                className="blog-body mb-5"
                dangerouslySetInnerHTML={{ __html: blogPost.content }}
              />

              {/* Tags */}
              <div className="blog-tags mb-4">
                {blogPost.tags.map((tag, index) => (
                  <Link key={index} to={``} className="blog-tag">
                    #{tag}
                  </Link>
                ))}
              </div>

              {/* Partage sur les réseaux sociaux */}
              <div className="blog-share mb-5">
                <h5 className="share-title">Partager cet article</h5>
                <div className="social-buttons">
                  <a href="#" className="social-button linkedin">
                    <FaLinkedin />
                  </a>
                  <a href="#" className="social-button twitter">
                    <FaTwitter />
                  </a>
                  <a href="#" className="social-button facebook">
                    <FaFacebook />
                  </a>
                </div>
              </div>

              {/* Bouton Retour */}
              <div className="blog-actions mb-5">
                <Link to="/actualites/blog" className="btn btn-back">
                  <FaChevronLeft className="me-2" /> Retour au blog
                </Link>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              {/* À propos de l'auteur */}
              <div className="sidebar-widget author-widget">
                <h4 className="widget-title">À propos de l'auteur</h4>
                <div className="author-profile">
                  <div className="author-image">
                    <img
                      src="../assets/images/image5.png"
                      alt={blogPost.author}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                  <div className="author-info">
                    <h5 className="author-name">{blogPost.author}</h5>
                    <p className="author-title">{blogPost.authorTitle}</p>
                    <p className="author-bio">
                      Expert-comptable spécialisé dans l'application des normes
                      comptables OHADA et l'accompagnement des entreprises dans
                      la mise en conformité de leurs états financiers. Fort
                      d'une expertise approfondie en évaluation d'actifs et
                      dépréciation d'immobilisations.
                    </p>
                  </div>
                </div>
              </div>

              {/* Articles similaires */}

              {/* Widget Newsletter */}
              <div className="sidebar-widget newsletter-widget">
                <h4 className="widget-title">Newsletter</h4>
                <p className="newsletter-desc">
                  Recevez nos conseils sur les normes comptables OHADA et les
                  dernières actualités en matière d'évaluation d'actifs
                </p>
                <form className="newsletter-form">
                  <div className="form-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Votre adresse email"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    S'abonner
                  </button>
                </form>
              </div>

              {/* Widget Liens utiles */}
              <div className="sidebar-widget categories-widget">
                <h4 className="widget-title">Ressources OHADA</h4>
                <ul className="categories-list">
                  <li>
                    <a
                      href="https://www.ohada.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Site officiel OHADA <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.ohada.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Jurisprudence OHADA <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      Actes uniformes <span>→</span>
                    </a>
                  </li>
                  <li>
                    <Link to="/services/audit-conseil">
                      Nos services comptables <span>→</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        /* Styles généraux */
        .blog-content {
          background-color: #f8f9fa;
        }

        /* Fil d'Ariane */
        .breadcrumb {
          background-color: transparent;
          padding: 0;
          margin-bottom: 0;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: #6c757d;
        }

        .breadcrumb-item a {
          color: #6c757d;
          text-decoration: none;
        }

        .breadcrumb-item.active {
          color: #212529;
          font-weight: 500;
        }

        /* En-tête du blog */
        .blog-header {
          margin-bottom: 2rem;
        }

        .blog-title {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
          line-height: 1.2;
        }

        .category-badge {
          display: inline-block;
          background: linear-gradient(to right, #dc3545, #198754);
          color: white;
          padding: 6px 15px;
          border-radius: 30px;
          font-size: 14px;
          font-weight: 600;
        }

        .blog-meta {
          color: #6c757d;
          font-size: 14px;
          gap: 20px;
        }

        .meta-item {
          gap: 5px;
        }

        .meta-icon {
          font-size: 14px;
          margin-right: 5px;
        }

        /* Image principale */
        .blog-featured-image {
          max-width: 60%; 
          height: auto; 
          border-radius: 10px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        /* Extrait */
        .blog-excerpt .lead {
          font-size: 1.25rem;
          font-weight: 300;
          line-height: 1.6;
          color: #495057;
        }

        /* Contenu du blog */
        .blog-body {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #212529;
        }

        .blog-body h3 {
          margin-top: 2rem;
          margin-bottom: 1rem;
          font-weight: 700;
          color: #212529;
        }

        .blog-body h4 {
          margin-top: 1.5rem;
          margin-bottom: 0.8rem;
          font-weight: 600;
          color: #343a40;
        }

        .blog-body h5 {
          margin-top: 1.2rem;
          margin-bottom: 0.6rem;
          font-weight: 600;
          color: #28a745;
        }

        .blog-body p {
          margin-bottom: 1.5rem;
        }

        .blog-body ul,
        .blog-body ol {
          margin-bottom: 1.5rem;
          padding-left: 1.5rem;
        }

        .blog-body li {
          margin-bottom: 0.8rem;
        }

        .blog-body blockquote {
          border-left: 4px solid #dc3545;
          padding-left: 1.5rem;
          font-style: italic;
          margin: 2rem 0;
          color: #495057;
          background-color: #f8f9fa;
          padding: 1.5rem;
          border-radius: 0 8px 8px 0;
        }

        .blog-body a {
          color: #dc3545;
          text-decoration: none;
        }

        .blog-body a:hover {
          text-decoration: underline;
        }

        /* Boîte d'exemple */
        .example-box {
          margin: 2rem 0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        /* Diagramme de processus */
        .process-diagram {
          text-align: center;
          margin: 2rem 0;
          padding: 1rem;
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        /* Tags */
        .blog-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 2rem;
        }

        .blog-tag {
          display: inline-block;
          background-color: #e9ecef;
          color: #495057;
          padding: 5px 12px;
          border-radius: 20px;
          text-decoration: none;
          font-size: 13px;
          transition: all 0.3s ease;
        }

        .blog-tag:hover {
          background-color: #dc3545;
          color: white;
        }

        /* Partage social */
        .blog-share {
          margin-top: 2rem;
          padding-top: 1.5rem;
          border-top: 1px solid #dee2e6;
        }

        .share-title {
          font-size: 1rem;
          margin-bottom: 1rem;
          color: #495057;
        }

        .social-buttons {
          display: flex;
          gap: 15px;
        }

        .social-button {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: transform 0.3s ease;
        }

        .social-button:hover {
          transform: translateY(-3px);
        }

        .linkedin {
          background-color: #0077b5;
        }

        .twitter {
          background-color: #1da1f2;
        }

        .facebook {
          background-color: #4267b2;
        }

        /* Bouton retour */
        .btn-back {
          display: inline-flex;
          align-items: center;
          background-color: white;
          color: #495057;
          padding: 10px 20px;
          border-radius: 30px;
          text-decoration: none;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          font-weight: 500;
        }

        .btn-back:hover {
          background-color: #f8f9fa;
          transform: translateX(-5px);
        }

        /* Sidebar Widgets */
        .sidebar-widget {
          background-color: white;
          border-radius: 8px;
          padding: 25px;
          margin-bottom: 30px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
        }

        .widget-title {
          font-size: 1.25rem;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #f0f0f0;
          position: relative;
        }

        .widget-title:after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 60px;
          height: 2px;
          background: linear-gradient(to right, #dc3545, #198754);
        }

        /* Widget Auteur */
        .author-profile {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          margin-bottom: 15px;
        }

        .author-image {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 15px;
        }

        .author-name {
          font-size: 18px;
          margin-bottom: 5px;
        }

        .author-title {
          font-size: 14px;
          color: #dc3545;
          margin-bottom: 10px;
          font-weight: 500;
        }

        .author-bio {
          font-size: 14px;
          color: #6c757d;
          margin-bottom: 0;
        }

        /* Widget Articles similaires */
        .similar-blogs {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .similar-blog {
          display: flex;
          text-decoration: none;
          color: inherit;
          background-color: #f8f9fa;
          border-radius: 8px;
          overflow: hidden;
          transition: transform 0.3s ease;
        }

        .similar-blog:hover {
          transform: translateY(-3px);
        }

        .similar-blog-image {
          width: 100px;
          height: 70px;
          flex-shrink: 0;
          position: relative;
        }

        .similar-blog-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .similar-blog-image .category-badge {
          position: absolute;
          top: 5px;
          left: 5px;
          padding: 2px 8px;
          font-size: 10px;
        }

        .similar-blog-content {
          padding: 10px;
        }

        .similar-blog-title {
          font-size: 15px;
          margin-bottom: 5px;
          line-height: 1.3;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .similar-blog-date {
          font-size: 12px;
          color: #6c757d;
          display: flex;
          align-items: center;
        }

        /* Widget Newsletter */
        .newsletter-desc {
          margin-bottom: 15px;
          color: #6c757d;
          font-size: 14px;
        }

        .btn-primary {
          background: linear-gradient(45deg, #dc3545, #198754);
          border: none;
          border-radius: 30px;
          padding: 12px 25px;
          font-weight: 600;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);
        }

        .btn-primary::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          transition: left 0.5s ease;
        }

        .btn-primary:hover::before {
          left: 100%;
        }

        .newsletter-form .form-control {
          border-radius: 25px;
          border: 2px solid #e9ecef;
          padding: 12px 20px;
          transition: all 0.3s ease;
        }

        .newsletter-form .form-control:focus {
          border-color: #dc3545;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
        }

        /* Widget Liens utiles */
        .categories-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .categories-list li {
          margin-bottom: 12px;
        }

        .categories-list a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 15px;
          background-color: #f8f9fa;
          color: #495057;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.3s ease;
          font-weight: 500;
        }

        .categories-list a:hover {
          background-color: #dc3545;
          color: white;
          transform: translateX(5px);
        }

        .categories-list a span {
          font-weight: bold;
          transition: transform 0.3s ease;
        }

        .categories-list a:hover span {
          transform: translateX(5px);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .blog-title {
            font-size: 2rem;
          }

          .blog-meta {
            flex-direction: column;
            gap: 10px;
            align-items: flex-start;
          }

          .meta-item {
            width: 100%;
          }

          .blog-body {
            font-size: 1rem;
          }

          .social-buttons {
            justify-content: center;
          }

          .author-profile {
            text-align: center;
          }

          .similar-blog {
            flex-direction: column;
          }

          .similar-blog-image {
            width: 100%;
            height: 150px;
          }

          .categories-list a {
            padding: 10px 12px;
          }
        }

        @media (max-width: 768px) {
          .blog-title {
            font-size: 2rem;
          }

          .blog-meta {
            flex-direction: column;
            gap: 10px;
            align-items: flex-start;
          }

          .meta-item {
            width: 100%;
          }

          .blog-body {
            font-size: 1rem;
          }

          .social-buttons {
            justify-content: center;
          }

          .author-profile {
            text-align: center;
          }

          .similar-blog {
            flex-direction: column;
          }

          .similar-blog-image {
            width: 100%;
            height: 150px;
          }

          .categories-list a {
            padding: 10px 12px;
          }
        }

        @media (max-width: 768px) {
          .author-profile {
            flex-direction: row;
            text-align: left;
            gap: 15px;
          }

          .author-image {
            width: 80px;
            height: 80px;
            margin-bottom: 0;
            flex-shrink: 0;
          }

          .author-info {
            flex: 1;
          }
        }

        /* Style pour les tableaux si présents dans le contenu */
        .blog-body table {
          width: 100%;
          border-collapse: collapse;
          margin: 2rem 0;
          background-color: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .blog-body th,
        .blog-body td {
          padding: 12px 15px;
          text-align: left;
          border-bottom: 1px solid #e9ecef;
        }

        .blog-body th {
          background-color: #f8f9fa;
          font-weight: 600;
          color: #495057;
        }

        .blog-body tr:hover {
          background-color: #f8f9fa;
        }

        /* Style pour les codes inline */
        .blog-body code {
          background-color: #f8f9fa;
          color: #e83e8c;
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 0.9em;
          font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
        }

        /* Style pour les blocs de code */
        .blog-body pre {
          background-color: #f8f9fa;
          border: 1px solid #e9ecef;
          border-radius: 8px;
          padding: 20px;
          overflow-x: auto;
          margin: 1.5rem 0;
        }

        .blog-body pre code {
          background: none;
          color: #495057;
          padding: 0;
          font-size: 0.95em;
        }
      `}</style>
    </>
  );
};
export default DetailBlog4;
